// Console D's callout row (components.css .callout): a round glyph, warn or crash, and the text.
import type { ReactNode } from 'react'

/** Console D's callout row: a round glyph, warn or crash, and the text. */
export function Callout({ crash, children }: { crash: boolean; children: ReactNode }) {
  return (
    <div className="callout">
      <span className={crash ? 'g crash' : 'g'} aria-hidden="true">
        !
      </span>
      <div>{children}</div>
    </div>
  )
}
